function getUrlSearchParams() {
  return new URLSearchParams(window.location.search);
}

function has(paramName) {
  return getUrlSearchParams().has(paramName);
}

function get(paramName) {
  return getUrlSearchParams().get(paramName);
}

function getAll(paramName) {
  return getUrlSearchParams().getAll(paramName);
}

function append(paramName, value) {
  const urlSearchParams = getUrlSearchParams();
  urlSearchParams.append(paramName, value ? value.toString() : null);

  return toString(urlSearchParams);
}

function set(paramName, value) {
  const urlSearchParams = getUrlSearchParams();
  urlSearchParams.set(paramName, value);

  return toString(urlSearchParams);
}

function del(paramName) {
  const urlSearchParams = getUrlSearchParams();
  urlSearchParams.delete(paramName);

  return toString(urlSearchParams);
}

function toString(urlSearchParams) {
  const value = (urlSearchParams || getUrlSearchParams()).toString();
  return value.length ? '?' + value : value;
}

export default {
  has,
  get,
  getAll,
  append,
  set,
  del,
  toString
}
